// extracted by mini-css-extract-plugin
export default {"collectionRecord":"collectionRecord_collectionRecord__NnuHD"};